/* 🤖 this file was generated by svg-to-ts */
export const matIconRoofing: {
  name: 'roofing';
  data: string;
} = {
  name: 'roofing',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 18h-2v-2h2v2zm2-4H9v6h6v-6zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3l-3-2.7z"/></svg>`
};
